import api from './api';

import { config } from '../config/env';

const API_URL = config.API_URL;

export const authService = {
    async register(data) {
        const response = await api.post('/auth/register', data);
        // Identity Service returns accessToken and refreshToken
        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken);
            localStorage.setItem('refreshToken', response.data.refreshToken);
        }
        return response.data;
    },

    async login(email, password) {
        const response = await api.post('/auth/login', { email, password });
        // Identity Service returns accessToken and refreshToken
        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken);
            localStorage.setItem('refreshToken', response.data.refreshToken);
        }
        return response.data;
    },

    /**
     * OAuth SSO Login - Redirects to backend which handles PKCE securely
     * Tokens stored in HttpOnly cookies (XSS-proof)
     */
    loginWithSSO() {
        // Simply redirect to backend OAuth endpoint
        // Backend handles PKCE generation, token exchange, everything
        window.location.href = `${API_URL}/api/auth/oauth/login`;
    },

    async getCurrentUser() {
        const response = await api.get('/auth/me');
        return response.data;
    },

    async refreshToken() {
        const refreshToken = localStorage.getItem('refreshToken');
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }

        const response = await api.post('/auth/refresh', { refreshToken });
        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken);
            // Refresh token might be rotated
            if (response.data.refreshToken) {
                localStorage.setItem('refreshToken', response.data.refreshToken);
            }
        }
        return response.data;
    },

    async logout() {
        const refreshToken = localStorage.getItem('refreshToken');
        const token = localStorage.getItem('token');

        try {
            // 1. If we have a JWT refresh token, revoke it
            if (refreshToken) {
                await api.post('/auth/logout', { refreshToken, token });
            }

            // 2. Always attempt to logout from OAuth (clears cookies and revokes session)
            // This is safe even for non-OAuth users as it just clears empty cookies
            await api.post('/auth/oauth/logout');

        } catch (error) {
            console.error('Logout error:', error);
        } finally {
            // 3. Clear all local storage
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('currentWorkspaceId');
            localStorage.removeItem('user');

            // 4. Redirect to login if not already there
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
    },

    /**
     * OAuth SSO Logout - Alias for logout() since it now handles both
     */
    async logoutSSO() {
        return this.logout();
    },

    getToken() {
        return localStorage.getItem('token');
    },

    getRefreshToken() {
        return localStorage.getItem('refreshToken');
    },

    /**
     * Check if user is authenticated
     * Supports both JWT (localStorage) and OAuth (cookies)
     * Returns true if either authentication method is valid
     */
    async isAuthenticated() {
        // Quick check: if we have a token in localStorage, assume authenticated
        // (will be validated by API interceptor if expired)
        if (this.getToken()) {
            return true;
        }

        // Otherwise, check if there's a valid OAuth session (cookies)
        try {
            await this.getCurrentUser();
            return true;
        } catch (error) {
            return false;
        }
    }
};

